import {
  COMMAND_EXECUTION_ERROR,
  COMMAND_VALIDATION_ERROR,
  REPORTS_COMMAND_EXECUTION_ERROR,
  TASKS_COMMAND_EXECUTION_ERROR,
  COMMAND_EXECUTION_WARNING,
  COMMAND_EXECUTION_INFORMATION
} from "actions/eventTypes";

export const errorEvents = [
  COMMAND_EXECUTION_ERROR,
  COMMAND_VALIDATION_ERROR,
  REPORTS_COMMAND_EXECUTION_ERROR,
  TASKS_COMMAND_EXECUTION_ERROR
];

export const warningEvents = [COMMAND_EXECUTION_WARNING];

export const informationEvents = [COMMAND_EXECUTION_INFORMATION];
